import { Card } from '@ps/isp-web-component-library';
import React from 'react';

import styles from './Promotion.scss';

export const Promotion: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Card className={styles.promo}>{children}</Card>
);

export default Promotion;
